(function (scope) {
  'use strict';

  var installations = new WeakMap();
  var navigation = /^\/(?:products|collections|pages|blogs|policies|search)(?:\/|$)/;
  var relativeNavigation = /^(?:products|collections|pages|blogs|policies|search)(?:\/|[?#]|$)/;
  var files = /\.(?:js|json|xml|css|txt|pdf|png|jpe?g|gif|svg|webp|avif|ico|woff2?|ttf|mp4|mov)$/i;

  function localizeUrl(value, options) {
    if (typeof value !== 'string' || !value.trim()) return value;
    var raw = value.trim();
    if (/^(?:#|\?|mailto:|tel:|javascript:|data:)/i.test(raw)) return value;
    if (!/^(?:\/|https?:\/\/)/i.test(raw) && !relativeNavigation.test(raw)) return value;
    var pathText = raw.split(/[?#]/, 1)[0].replace(/%2e/ig, '.').replace(/\\/g, '/');
    if (/(?:^|\/)\.{1,2}(?:\/|$)/.test(pathText)) return value;
    options = options || {};
    var root = options.root || '/';
    if (!/^\/(?:[a-z0-9][a-z0-9-]*\/?)?$/i.test(root)) return value;
    var prefix = root.replace(/\/$/, '');
    var base;
    var target;
    try {
      base = new URL(options.origin);
      target = new URL(relativeNavigation.test(raw) ? '/' + raw : raw, base.origin + '/');
    } catch (_) { return value; }
    if (!/^https?:$/.test(target.protocol) || target.username || target.password || target.port && target.origin !== base.origin) return value;
    var primary = String(options.primaryHost || base.hostname).toLowerCase();
    var hosts = [base.hostname, primary, primary.replace(/^www\./, ''), 'www.' + primary.replace(/^www\./, ''), String(options.storeHost || '').toLowerCase()];
    if (hosts.indexOf(target.hostname) === -1) return value;
    var legacyPath = target.pathname.replace(/\/$/, '').toLowerCase();
    var legacy = legacyPath === '/apps/17track' || prefix && legacyPath === (prefix + '/apps/17track').toLowerCase();
    var contactAlias = legacyPath === '/contact' || prefix && legacyPath === (prefix + '/contact').toLowerCase();
    var joinedCollection = prefix && legacyPath === (prefix + 'collections/frontpage').toLowerCase();
    var pathname = legacy ? '/pages/track-order' : contactAlias ? '/pages/contact' : joinedCollection ? '/collections/frontpage' : target.pathname;
    if ((!navigation.test(pathname) && pathname !== '/') || files.test(pathname)) return value;
    if (!prefix && !legacy && !contactAlias && !joinedCollection) return value;
    return prefix + pathname + target.search + target.hash;
  }

  function install(doc, options) {
    if (!doc || !doc.querySelectorAll) return null;
    if (installations.has(doc)) return installations.get(doc);
    var view = doc.defaultView || scope;
    var script = doc.currentScript;
    var primaryHost = options && options.primaryHost || script && script.dataset.shopHost;
    var storeHost = options && options.storeHost || script && script.dataset.storeHost;
    function settings() {
      return {
        root: options && options.root || view.Shopify && view.Shopify.routes && view.Shopify.routes.root || script && script.dataset.localeRoot || '/',
        origin: options && options.origin || view.location.origin,
        primaryHost: primaryHost,
        storeHost: storeHost || view.Shopify && view.Shopify.shop
      };
    }
    function rewrite(anchor) {
      if (!anchor || !anchor.getAttribute || anchor.hasAttribute('download') || anchor.hasAttribute('hreflang') || anchor.hasAttribute('lang') ||
          anchor.closest('localization-form, form[action*="/localization"], [data-locale-switch]')) return;
      var original = anchor.getAttribute('href');
      var next = localizeUrl(original, settings());
      if (next !== original) anchor.setAttribute('href', next);
    }
    function refresh(node) {
      if (!node || (node.nodeType !== 1 && node.nodeType !== 9)) return;
      if (node.matches && node.matches('a[href]')) rewrite(node);
      if (node.querySelectorAll) node.querySelectorAll('a[href]').forEach(rewrite);
    }
    function activation(event) {
      var path = event.composedPath ? event.composedPath() : [event.target];
      var anchor = path.find(function (node) { return node && node.matches && node.matches('a[href]'); });
      if (!anchor && event.target && event.target.closest) anchor = event.target.closest('a[href]');
      rewrite(anchor);
    }
    var observer = typeof view.MutationObserver === 'function' ? new view.MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') rewrite(record.target);
        else record.addedNodes.forEach(refresh);
      });
    }) : null;
    refresh(doc);
    if (observer) observer.observe(doc.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    var events = ['click', 'auxclick', 'pointerdown', 'contextmenu'];
    events.forEach(function (name) { view.addEventListener(name, activation, { capture: true, passive: true }); });
    var state = {
      refresh: function () { refresh(doc); },
      destroy: function () {
        if (observer) observer.disconnect();
        events.forEach(function (name) { view.removeEventListener(name, activation, true); });
        installations.delete(doc);
      }
    };
    installations.set(doc, state);
    return state;
  }

  var api = { localizeUrl: localizeUrl, install: install };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (scope.document) {
    if (!scope.CharabancLocaleLinks) scope.CharabancLocaleLinks = api;
    scope.CharabancLocaleLinks.install(scope.document);
  }
})(typeof window !== 'undefined' ? window : globalThis);
